module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABDElEQVR4AWOgD7CYTBBxWfd0xZmja9CNXoZVtZZz+e4csbulqDaohy3ZdfKRYtBCNNVxQaE3SpiBqlE0ANVNWHHh////DXNOyvkvgCgVsOmcmaQLUfq4R+vrje0oNvA4zuhafBZIQrgmbgXH8gWASu/X8n842Pv/7x+gceh+gJjNbDkxN8zrVgnT3XLm1+sy/359+x8GsISSuF3zsjQVoMHP53j8fHEVou7Jqy9dS84axC5H1+DolXG6gAfiXKC6D59/ztl01SlnPVwBQgOr5YTaKAeIc3/++LXx0L3A8q1sttPQgxgC5B3rNmUrAJ2779j1tI59Qm6zccYgBOzqiqzo3SztO49wlA9KAADFiL+363hbkAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/MH.png
// module id = 1206
// module chunks = 0